
import { useState } from "react"
import "../Css_files/Certification.css"
import Navbar from "../Js_files/Navbar"
import Footer from "../Js_files/Footer"


const Certification = () => {
  const [activeTab, setActiveTab] = useState("overview")

  const certifications = [
    {
      id: 1,
      title: "Full Stack Web Development",
      duration: "6 Months",
      level: "Advanced",
      students: "2,500+",
      rating: 4.9,
      skills: ["React.js", "Node.js", "MongoDB", "Express.js", "JavaScript ES6+"],
    },
    {
      id: 2,
      title: "Data Science & Analytics",
      duration: "8 Months",
      level: "Professional",
      students: "1,800+",
      rating: 4.8,
      skills: ["Python", "Machine Learning", "SQL", "Tableau", "Statistics"],
    },
    {
      id: 3,
      title: "Cloud Computing & DevOps",
      duration: "5 Months",
      level: "Expert",
      students: "1,200+",
      rating: 4.9,
      skills: ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform"],
    },
    {
      id: 4,
      title: "Mobile App Development",
      duration: "4 Months",
      level: "Intermediate",
      students: "3,000+",
      rating: 4.7,
      skills: ["React Native", "Flutter", "iOS", "Android", "Firebase"],
    },
  ]

  return (
    <>
    <Navbar/><br></br><br></br>
    <div className="cert-container">
      <div className="cert-hero-section">
        <div className="cert-hero-content">
          <div className="cert-company-logo">
            <div className="cert-logo-icon">PT</div>
            <h1 className="cert-company-name">Profenaa Technologies</h1>
          </div>
          <h2 className="cert-hero-title">Professional Certification Programs</h2>
          <p className="cert-hero-subtitle">
            Advance your career with industry-recognized certifications from Profenaa Technologies. Our comprehensive
            programs are designed by experts to meet current industry demands and prepare you for success in the digital
            economy.
          </p>
        </div>
      </div>

      <div className="cert-navigation">
        <div className="cert-nav-container">
          <button
            className={`cert-nav-button ${activeTab === "overview" ? "cert-nav-active" : ""}`}
            onClick={() => setActiveTab("overview")}
          >
            Overview
          </button>
          <button
            className={`cert-nav-button ${activeTab === "programs" ? "cert-nav-active" : ""}`}
            onClick={() => setActiveTab("programs")}
          >
            Programs
          </button>
          <button
            className={`cert-nav-button ${activeTab === "benefits" ? "cert-nav-active" : ""}`}
            onClick={() => setActiveTab("benefits")}
          >
            Benefits
          </button>
          <button
            className={`cert-nav-button ${activeTab === "process" ? "cert-nav-active" : ""}`}
            onClick={() => setActiveTab("process")}
          >
            Process
          </button>
        </div>
      </div>

      {activeTab === "overview" && (
        <div className="cert-section">
          <div className="cert-content">
            <h3 className="cert-section-title">Why Choose Profenaa Technologies Certification?</h3>
            <div className="cert-overview-grid">
              <div className="cert-overview-card">
                <div className="cert-overview-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                </div>
                <h4>Industry Recognition</h4>
                <p>
                  Our certifications are recognized by Fortune 500 companies and leading tech organizations worldwide.
                  Profenaa Technologies maintains strategic partnerships with industry leaders to ensure our curriculum
                  meets the highest professional standards and current market demands.
                </p>
              </div>

              <div className="cert-overview-card">
                <div className="cert-overview-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <h4>Expert Instructors</h4>
                <p>
                  Learn from industry veterans with 10+ years of experience. Our instructors are certified professionals
                  who have worked with top-tier companies and bring real-world insights to every lesson. Each instructor
                  holds advanced degrees and multiple professional certifications.
                </p>
              </div>

              <div className="cert-overview-card">
                <div className="cert-overview-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <h4>Blockchain Verified</h4>
                <p>
                  All certificates are secured using blockchain technology, making them tamper-proof and instantly
                  verifiable by employers worldwide. Our distributed ledger system ensures permanent record keeping and
                  prevents fraudulent certificates, giving you credibility that lasts.
                </p>
              </div>

              <div className="cert-overview-card">
                <div className="cert-overview-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
                    <line x1="12" y1="22.08" x2="12" y2="12" />
                  </svg>
                </div>
                <h4>Hands-on Projects</h4>
                <p>
                  Build real-world projects that showcase your skills to potential employers. Our project-based learning
                  approach ensures you gain practical experience with the latest tools and technologies. Each program
                  includes portfolio-worthy projects that demonstrate your expertise.
                </p>
              </div>

              <div className="cert-overview-card">
                <div className="cert-overview-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12,6 12,12 16,14" />
                  </svg>
                </div>
                <h4>Lifetime Access</h4>
                <p>
                  Get lifetime access to course materials, updates, and our alumni network. As technology evolves, we
                  continuously update our content to keep you current with industry trends. Join a community of 50,000+
                  certified professionals for ongoing support and networking.
                </p>
              </div>

              <div className="cert-overview-card">
                <div className="cert-overview-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                    <path d="M9 14l2 2 4-4" />
                  </svg>
                </div>
                <h4>Career Support</h4>
                <p>
                  Receive dedicated career support including resume review, interview preparation, and job placement
                  assistance. Our career services team works with you throughout your journey and beyond certification
                  to help you achieve your professional goals and advance your career.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "programs" && (
        <div className="cert-section">
          <div className="cert-content">
            <h3 className="cert-section-title">Our Certification Programs</h3>
            <div className="cert-programs-grid">
              {certifications.map((cert) => (
                <div key={cert.id} className="cert-program-card">
                  <div className="cert-program-header">
                    <h4 className="cert-program-title">{cert.title}</h4>
                    <div className="cert-program-level">{cert.level}</div>
                  </div>
                  <div className="cert-program-details">
                    <div className="cert-program-meta">
                      <span className="cert-program-duration">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12,6 12,12 16,14" />
                        </svg>
                        {cert.duration}
                      </span>
                      <span className="cert-program-students">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        {cert.students} Students
                      </span>
                      <span className="cert-program-rating">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
                        </svg>
                        {cert.rating}/5.0
                      </span>
                    </div>
                    <div className="cert-skills-section">
                      <h5>Key Skills You'll Learn:</h5>
                      <div className="cert-skills-list">
                        {cert.skills.map((skill, index) => (
                          <span key={index} className="cert-skill-tag">
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {activeTab === "benefits" && (
        <div className="cert-section">
          <div className="cert-content">
            <h3 className="cert-section-title">Certification Benefits</h3>
            <div className="cert-benefits-container">
              <div className="cert-benefits-list">
                <div className="cert-benefit-item">
                  <div className="cert-benefit-icon">✓</div>
                  <div className="cert-benefit-content">
                    <h4>Career Advancement</h4>
                    <p>
                      95% of our certified professionals report career advancement within 6 months of completion. Our
                      certifications open doors to senior positions, leadership roles, and specialized career paths in
                      top technology companies worldwide.
                    </p>
                  </div>
                </div>

                <div className="cert-benefit-item">
                  <div className="cert-benefit-icon">✓</div>
                  <div className="cert-benefit-content">
                    <h4>Salary Increase</h4>
                    <p>
                      Certified professionals earn an average of 40% more than their non-certified counterparts. Our
                      industry partnerships ensure that employers recognize and value Profenaa Technologies
                      certifications with competitive compensation packages.
                    </p>
                  </div>
                </div>

                <div className="cert-benefit-item">
                  <div className="cert-benefit-icon">✓</div>
                  <div className="cert-benefit-content">
                    <h4>Global Recognition</h4>
                    <p>
                      Our certifications are recognized in over 40 countries and by more than 500 partner companies.
                      Whether you're looking for opportunities locally or internationally, our certifications provide
                      the credibility you need to succeed.
                    </p>
                  </div>
                </div>

                <div className="cert-benefit-item">
                  <div className="cert-benefit-icon">✓</div>
                  <div className="cert-benefit-content">
                    <h4>Professional Network</h4>
                    <p>
                      Join an exclusive network of 50,000+ certified professionals, industry experts, and hiring
                      managers. Access exclusive job opportunities, mentorship programs, and professional development
                      resources through our alumni network.
                    </p>
                  </div>
                </div>

                <div className="cert-benefit-item">
                  <div className="cert-benefit-icon">✓</div>
                  <div className="cert-benefit-content">
                    <h4>Continuous Learning</h4>
                    <p>
                      Stay current with evolving technologies through our continuous learning platform. Certified
                      professionals receive free access to new course updates, webinars, and industry insights to
                      maintain their competitive edge throughout their careers.
                    </p>
                  </div>
                </div>

                <div className="cert-benefit-item">
                  <div className="cert-benefit-icon">✓</div>
                  <div className="cert-benefit-content">
                    <h4>Job Placement Support</h4>
                    <p>
                      Our dedicated career services team provides personalized job placement support, including resume
                      optimization, interview coaching, and direct connections with hiring managers at partner
                      companies. We're committed to your success beyond certification.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "process" && (
        <div className="cert-section">
          <div className="cert-content">
            <h3 className="cert-section-title">Certification Process</h3>
            <div className="cert-process-timeline">
              <div className="cert-process-step">
                <div className="cert-process-number">1</div>
                <div className="cert-process-content">
                  <h4>Program Selection & Enrollment</h4>
                  <p>
                    Choose from our comprehensive range of certification programs based on your career goals and current
                    skill level. Our career counselors provide personalized guidance to help you select the most
                    suitable program for your professional development needs.
                  </p>
                </div>
              </div>

              <div className="cert-process-step">
                <div className="cert-process-number">2</div>
                <div className="cert-process-content">
                  <h4>Interactive Learning Phase</h4>
                  <p>
                    Engage in comprehensive coursework featuring live sessions, hands-on labs, and real-world projects.
                    Our expert instructors provide personalized feedback and mentorship throughout your learning
                    journey, ensuring you master both theoretical concepts and practical applications.
                  </p>
                </div>
              </div>

              <div className="cert-process-step">
                <div className="cert-process-number">3</div>
                <div className="cert-process-content">
                  <h4>Project Portfolio Development</h4>
                  <p>
                    Build a comprehensive portfolio of industry-relevant projects that demonstrate your expertise to
                    potential employers. Each project is designed to solve real business problems and showcase your
                    ability to apply learned concepts in practical scenarios.
                  </p>
                </div>
              </div>

              <div className="cert-process-step">
                <div className="cert-process-number">4</div>
                <div className="cert-process-content">
                  <h4>Comprehensive Assessment</h4>
                  <p>
                    Complete rigorous assessments including theoretical examinations, practical demonstrations, and
                    project presentations. Our multi-faceted evaluation process ensures that certified professionals
                    possess both deep knowledge and practical skills required for success in their field.
                  </p>
                </div>
              </div>

              <div className="cert-process-step">
                <div className="cert-process-number">5</div>
                <div className="cert-process-content">
                  <h4>Certification & Career Support</h4>
                  <p>
                    Receive your blockchain-verified certificate and gain access to our exclusive alumni network and
                    career services. Our ongoing support includes job placement assistance, career coaching, and
                    continuous learning opportunities to ensure your long-term professional success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="cert-cta-section">
        <div className="cert-cta-content">
          <h3>Ready to Advance Your Career?</h3>
          <p>
            Join thousands of professionals who have transformed their careers with Profenaa Technologies
            certifications. Start your journey today and unlock new opportunities in the digital economy.
          </p>
          <div className="cert-cta-buttons">
            <button className="cert-cta-primary">Explore Programs</button>
            <button className="cert-cta-secondary">Download Brochure</button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default Certification
